<template>
  <div class="list-wrapper">
    <div class="btn-feed-mobile">
      <Button
        title="Add Playlist"
        classType="primary"
        :eventFunction="toCreateHandler"
      />
    </div>
    <div class="flex">
      <div class="left-path">
        <span class="system">
          Collections
        </span>
        <span>
          / Playlists
        </span>
      </div>
      <div class="right-path">
        <LiveSearch
          :onSearch="onSearch"
          :maxlength="255"
        />
        <div class="btn-feed-full">
          <Button
            title="Add Playlist"
            classType="primary"
            :eventFunction="toCreateHandler"
          />
        </div>
      </div>
    </div>
    <div class="accounts-wrapper">
      <div class="ac-wrapper-header">
        <div class="th-name number">
          #
        </div>
        <div class="th-name company">
          <Sorting
            :sortField="`p.${sortedField.title}`"
            :currentSortedField="currentSortedField"
            :handleSortUp="handleSortUp"
            :handleSortDown="handleSortDown"
          />
          title
        </div>
        <div class="th-name company-id">
          <Sorting
            :sortField="`p.${sortedField.updatedAt}`"
            :currentSortedField="currentSortedField"
            :defaultSortUp="false"
            :handleSortUp="handleSortUp"
            :handleSortDown="handleSortDown"
          />
          last edited
        </div>
        <div class="th-name users-count">
          modified by
        </div>
        <div
          v-if="isAccountHasSubscriptionProvider"
          class="th-name users-count"
        >
          package
        </div>
        <div class="icons-name"></div>
      </div>
      <div
        v-if="!playlists.length"
        class="empty-search"
      >
        No Items to display
      </div>
      <div
        v-for="(item, key) in playlists"
        :key="item.id"
        class="account"
        @mouseover="onHoverElem(item)"
        @mouseleave="isHover = false"
      >
        <div class="td number">
          {{ getCurrentNumber(key) }}
        </div>
        <div
          class="td company"
          :title="item.title"
        >
          {{ item.title }}
        </div>
        <div class="td company-id">
          <span v-if="item.updatedAt">
            {{ item.updatedAt | timezone(getMainProfile.timezone) }}
          </span>
          <span v-else>-</span>
        </div>
        <div class="td users-count">
          {{ item.updatedBy ? item.updatedBy.fullName : '-' }}
        </div>

        <div
          v-if="isAccountHasSubscriptionProvider"
          class="td users-count"
        >
          {{ getEntitlementFeatureName(item.entitlementFeatureId) }}
        </div>

        <div class="feed-wrapper-icons">
          <div
            v-show="isHover && item.id === selectedId"
            :class="['icons-wrapper', (isHover && (item.id === selectedId))
              ? ''
              : 'icons-wrapper-hide'
            ]"
          >
            <div class="icon-edit">
              <div
                :title="'Go to Source'"
                @click="goToMediaFolder(item)"
              >
                <inline-svg
                  :src="iconSource"
                  class="svg-icon source-icon"
                >
                </inline-svg>
              </div>
            </div>
            <div
              class="icon-edit"
              :title="'Delete Playlist'"
            >
              <inline-svg
                :src="iconRemove"
                class="svg-icon remove"
                @click="onOpenModalForRemove(item)"
              >
              </inline-svg>
            </div>
            <div class="icon-edit">
              <router-link
                :to="{ path: `playlists/${item.id}` }"
                :title="editPlaylist"
              >
                <inline-svg
                  :src="iconEdit"
                  class="svg-icon"
                >
                </inline-svg>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AddPlaylistModal
      v-model="isAddingOpen"
      :modal="isAddingOpen"
      :onClose="onManuallyClose"
      :onSubmitManually="onSubmitManually"
    />
    <NotificationModal
      ref="modal"
      v-model="isModalOpen"
      :modal="isModalOpen"
      :title="'Delete Playlist'"
      :bodyMessage="bodyMessage"
      :warningMess="warningMess"
      :isInUseAsset="true"
      :onAccept="removePlaylist"
      :onClose="onClose"
    />
    <Pagination
      :action="getPaginationAction"
      :page="pagination.page"
      :totalPages="totalPages"
    />
  </div>
</template>

<script>
import {
  mapGetters,
  mapState,
} from 'vuex';
import {
  DELETE_PLAYLIST_REQUEST,
  GET_PLAYLIST_LIST_REQUEST,
} from '../../store/actions/playlist/playlist';
import { SET_OVERFLOW } from '../../store/actions/common';
import CONFIG from '../../constants/config';
import iconEdit from '../../assets/icons/icon-edit-acc.svg';
import iconCode from '../../assets/icons/icon-code.svg';
import iconSource from '../../assets/icons/icon-folder-source.svg';
import iconRemove from '../../assets/icons/icon-remove-role.svg';

import Button from '../../components/common/Button.vue';
import Sorting from '../../components/common/Sorting.vue';
import Pagination from '../../components/common/Pagination.vue';
import LiveSearch from '../../components/common/LiveSearch.vue';
import AddPlaylistModal from './AddPlaylistModal.vue';
import NotificationModal from '../../components/NotificationModal.vue';

export default {
  name: 'PlaylistList',
  components: {
    NotificationModal,
    AddPlaylistModal,
    Button,
    Sorting,
    Pagination,
    LiveSearch,
  },
  data() {
    return {
      generateFeedWidget: CONFIG.tooltips.generateFeedWidget,
      editPlaylist: 'Edit Playlist',
      enabledId: null,
      isEnabled: false,
      isModalOpen: false,
      isHover: false,
      selectedId: null,
      bodyMessage: '',
      warningMess: 'Deleting a Playlist will not result in deleting the Source Folder and its Media Items',
      filter: '',
      sortedField: {
        title: 'title',
        updatedAt: 'updatedAt',
      },
      currentSortedField: 'p.updatedAt',
      currentSortBy: 'DESC',
      isSortedUp: false,
      isSortedDown: false,
      iconEdit,
      iconCode,
      iconSource,
      iconRemove,
      modalData: {},
      showModal: false,
      isAddingOpen: false,
    };
  },
  computed: {
    ...mapState({
      playlists: (state) => state.playlist.playlistList,
      pagination: (state) => state.playlist.pagination,
      entitlementsFeatures: (state) => state.accounts.entitlementsFeatures,
    }),
    ...mapGetters([
      'getCurrentAccountId',
      'getMainProfile',
      'isAccountHasSubscriptionProvider',
    ]),
    totalPages() {
      return Math.ceil(this.pagination.total / this.pagination.limit);
    },
  },
  created() {
    const s = this.$route.name;
    document.title = s[0].toUpperCase() + s.slice(1);

    this.getPlaylistList();
  },
  methods: {
    getPlaylistList() {
      const params = {
        accountId: this.getCurrentAccountId,
        page: localStorage.getItem('playlist') || 1,
        filterValue: '',
        sortFiled: this.currentSortedField,
        sortBy: this.currentSortBy,
      };
      this.$store.dispatch(GET_PLAYLIST_LIST_REQUEST, params);
    },
    getEntitlementFeatureName(entitlementFeatureId) {
      if (!entitlementFeatureId) {
        return '-';
      }
      const feature = this.entitlementsFeatures.find((item) => item.id === entitlementFeatureId);
      return feature ? feature.name : entitlementFeatureId;
    },
    toCreateHandler() {
      this.isAddingOpen = true;
    },
    handleSortUp(field) {
      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
        filterValue: this.filter,
        sortFiled: field,
        sortBy: CONFIG.sort.sortUp,
      };
      this.currentSortedField = params.sortFiled;
      this.currentSortBy = params.sortBy;
      this.$store.dispatch(GET_PLAYLIST_LIST_REQUEST, params);
    },
    handleSortDown(field) {
      const params = {
        accountId: this.getCurrentAccountId,
        page: this.pagination.page,
        filterValue: this.filter,
        sortFiled: field,
        sortBy: CONFIG.sort.sortDown,
      };
      this.currentSortedField = params.sortFiled;
      this.currentSortBy = params.sortBy;
      this.$store.dispatch(GET_PLAYLIST_LIST_REQUEST, params);
    },
    onSearch(params) {
      this.filter = params.filterValue;
      const getParams = {
        accountId: this.getCurrentAccountId,
        page: params.page,
        filterValue: this.filter,
        sortFiled: this.currentSortedField,
        sortBy: this.currentSortBy,
      };
      this.$store.dispatch(GET_PLAYLIST_LIST_REQUEST, getParams);
    },
    getPaginationAction(page) {
      const params = {
        accountId: this.getCurrentAccountId,
        page,
        filterValue: this.filter,
        sortFiled: this.currentSortedField,
        sortBy: this.currentSortBy,
      };
      this.$store.dispatch(GET_PLAYLIST_LIST_REQUEST, params);
    },
    onHoverElem(item) {
      this.selectedId = item.id;
      this.isHover = true;
    },
    getCurrentNumber(key) {
      const { pagination } = this;
      return (pagination.page - 1) * pagination.limit + key + 1;
    },
    onClose() {
      this.isModalOpen = false;
    },
    onManuallyClose() {
      this.isAddingOpen = false;
    },
    onSubmitManually() {
      this.onManuallyClose();
      this.getPlaylistList();
    },
    goToMediaFolder(item) {
      sessionStorage.setItem('parentsPath', item.mediaFolder.pathIds.toString());
      window.open(`/media/folder/${item.mediaFolder.id}`, '_blank');
      // this.$router.push(`/media/folder/${item.mediaFolder.id}`);
    },
    onOpenModalForRemove(item) {
      const {
        deletePlaylistMessage,
      } = CONFIG.modals;
      this.$store.dispatch(SET_OVERFLOW, true);
      this.isModalOpen = true;
      this.enabledId = item.id;
      this.bodyMessage = deletePlaylistMessage;
    },
    removePlaylist() {
      const params = {
        accountId: this.getCurrentAccountId,
        playlistId: this.enabledId,
      };

      this.$store.dispatch(DELETE_PLAYLIST_REQUEST, params)
        .then(() => {
          this.$toasted.global.success({
            message: 'The Playlist has been successfully deleted',
          });
          this.getPlaylistList();
        })
        .catch((err) => {
          if (err.status === 400 && err.error === 'ITEM_HAS_DEPENDENCIES') {
            this.$toasted.global.error({
              message: 'This Playlist is in use by Video Apps Engine and cannot be deleted',
            });
          }
        });
    },
  },
};
</script>

<style scoped>
.list-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  padding: 25px 25px 25px 30px;
  width: 100%;
}

.add-feed {
  align-items: center;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 25px;
}

.accounts-wrapper {
  border: 1px solid #43434d;
  height: 89%;
  overflow-y: auto;
}

.ac-wrapper-header {
  background: #282a2e;
  display: flex;
  padding: 13px 0;
}

.th-name {
  align-items: center;
  display: flex;
  font-size: 12px;
  text-transform: uppercase;
}

.td {
  font-size: 14px;
  padding: 15px 0;
  word-break: break-word;
}

.number {
  padding-left: 21px;
  width: 67px;
}

.company {
  width: 20%;
}

.company-id {
  padding-left: 15px;
  width: 25%;
}

.users-count {
  margin-left: 30px;
  text-align: left;
  width: 32%;
}

.status {
  align-items: flex-start;
  display: flex;
  margin-left: 30px;
  text-align: center;
  width: 10%;
}

.icons-name {
  width: 120px;
}

.account {
  display: flex;
}

.account:hover {
  background: #383b40;
}

.status-ellipse {
  border-radius: 50%;
  height: 5px;
  margin-right: 6px;
  margin-top: 6px;
  width: 5px;
}

.icons-wrapper {
  align-items: flex-start;
  display: flex;
  flex: 0.95;
  justify-content: flex-end;
  min-width: 100px;
  padding: 9px;
  padding-left: 40px;
}

.feed-wrapper-icons {
  margin-right: 5px;
  min-width: 120px;
}

.svg-icon {
  cursor: pointer;
}

.icon-edit {
  margin-left: 31px;
}

.create-button {
  background: #2591cf;
  color: #fff;
  font-size: 16px;
  letter-spacing: normal;
  padding: 0 16px;
  text-transform: none;
}

.right-path {
  align-items: center;
  display: flex;
}

.empty-search {
  padding-top: 40px;
  text-align: center;
}

.icons-wrapper-hide {
  visibility: hidden;
}

.btn-feed-mobile {
  display: none;
}

.flex {
  align-items: center;
  display: flex;
  flex: 0;
  justify-content: space-between;
  margin-bottom: 25px;
  min-height: 40px;
}

.right-path {
  align-items: center;
  display: flex;
}

.system {
  color: #4c5057;
}

.source-icon {
  padding-top: 3px;
}

@media all and (max-width: 1850px) {
  .users-count {
    width: 7%;
  }

  .status {
    width: 7%;
  }
}

@media all and (max-width: 1600px) {
  .company-id {
    width: 19%;
  }
}

@media all and (max-width: 1024px) {
  .btn-feed-mobile {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 15px;
    min-height: 40px;
  }

  .btn-feed-full {
    display: none;
  }

  .search-wrapper {
    margin-right: 0;
  }
}
</style>
